import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function VAUP
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={31}
            adderFlag={20}
            showLabelInput={true}
            userConfiguration={true}
        />
    );
}
export default VAUP